"use strict";
/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Plot$ = exports.Plot$outboundSchema = exports.Plot$inboundSchema = void 0;
exports.plotToJSON = plotToJSON;
exports.plotFromJSON = plotFromJSON;
const z = __importStar(require("zod"));
const primitives_js_1 = require("../../../lib/primitives.js");
const schemas_js_1 = require("../../../lib/schemas.js");
const meta_js_1 = require("./meta.js");
const titlepolygon_js_1 = require("./titlepolygon.js");
/** @internal */
exports.Plot$inboundSchema = z
    .object({
    meta: z.nullable(meta_js_1.Meta$inboundSchema),
    polygons: z.array(titlepolygon_js_1.TitlePolygon$inboundSchema),
    total_plot_area_square_metres: z.nullable(z.number().int()),
}).transform((v) => {
    return (0, primitives_js_1.remap)(v, {
        "total_plot_area_square_metres": "totalPlotAreaSquareMetres",
    });
});
/** @internal */
exports.Plot$outboundSchema = z.object({
    meta: z.nullable(meta_js_1.Meta$outboundSchema),
    polygons: z.array(titlepolygon_js_1.TitlePolygon$outboundSchema),
    totalPlotAreaSquareMetres: z.nullable(z.number().int()),
}).transform((v) => {
    return (0, primitives_js_1.remap)(v, {
        totalPlotAreaSquareMetres: "total_plot_area_square_metres",
    });
});
/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
var Plot$;
(function (Plot$) {
    /** @deprecated use `Plot$inboundSchema` instead. */
    Plot$.inboundSchema = exports.Plot$inboundSchema;
    /** @deprecated use `Plot$outboundSchema` instead. */
    Plot$.outboundSchema = exports.Plot$outboundSchema;
})(Plot$ || (exports.Plot$ = Plot$ = {}));
function plotToJSON(plot) {
    return JSON.stringify(exports.Plot$outboundSchema.parse(plot));
}
function plotFromJSON(jsonString) {
    return (0, schemas_js_1.safeParse)(jsonString, (x) => exports.Plot$inboundSchema.parse(JSON.parse(x)), `Failed to parse 'Plot' from JSON`);
}
//# sourceMappingURL=plot.js.map